import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

export default function PhoneNumberInput({ formValues, formErrors, setFormValues, setFormErrors, countries }) {
    const selectedCountry = countries.find(c => c.value === formValues.country);
    const phoneCode = selectedCountry?.callingCode || '';
    const flag = selectedCountry?.flag


    const handlePhoneChange = (e) => {
        const phoneValue = e.target.value;

        setFormValues(prev => ({ ...prev, phone: phoneValue}));

        if (phoneValue.trim() === '') {
            setFormErrors(prev => ({ ...prev, phone: 'Phone number is required' }));
        } else if (!validatePhoneNumber(phoneValue, selectedCountry?.value)) {
            setFormErrors(prev => ({ ...prev, phone: 'Invalid phone number' }));
        } else {
            setFormErrors(prev => ({ ...prev, phone: '' }));
        }
    };

    return (
        <TextField error={!!formErrors.phone} helperText={formErrors.phone} placeholder="Phone Number" name="phone" variant="outlined" fullWidth size="small" value={formValues.phone} onChange={handlePhoneChange} className="custom-textfield"
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <span style={{ fontSize: '14px', marginRight: 4 }}><img src={flag} alt={formValues.country} width={30} /></span>
                        <span style={{fontSize: '14px'}}>+{phoneCode}</span>
                    </InputAdornment>

                )
            }}
        />
    );
}

function validatePhoneNumber(phone, countryCode) {
    if (!phone) return false;
    if (countryCode === 'IN') return phone.length >= 10;
    if (countryCode === 'US') return phone.length >= 10;
    return phone.length > 5;
}
